import { baseElementSchema } from "@/Components/Exercises/Elements/base";
import { stringReturnOpSchema } from "@/Components/Exercises/LogicOperation";
import { z } from "zod";

export const textAreaElementSchema = baseElementSchema.extend({
    type: z.literal("textArea"),
    question: z.union([z.string(), stringReturnOpSchema]),
});
export const textAreaElementDataSchema = z.object({
    answer: z.string(),
});
export type TextAreaElement = z.infer<typeof textAreaElementSchema>;
export type TextAreaElementData = z.infer<typeof textAreaElementDataSchema>;
